/* Shared native product-form bridge. UpCart methods/events verified in the store's loaded bundle. */
(() => {
  'use strict';
  if (window.GFFCart) return;
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let cleanupPending = false;

  async function request(path, body) {
    const response = await fetch(`${root}${path}`, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Your cart could not be updated. Please try again.');
    return data;
  }

  function serialize(operation) {
    const result = queue.then(operation);
    queue = result.catch(() => {});
    return result;
  }

  async function refresh() {
    if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
    document.dispatchEvent(new CustomEvent('gff:cart-updated'));
  }

  async function open() {
    await refresh();
    if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
    else window.location.assign(`${root}cart`);
  }

  async function removeOrphanGifts() {
    const cart = await request('cart.js');
    const setTokens = new Set(cart.items
      .filter(item => item.properties?._gff_set_role === 'set')
      .map(item => item.properties._gff_set_bundle).filter(Boolean));
    const updates = {};
    for (const item of cart.items) {
      const properties = item.properties || {};
      if (properties._gff_set_role === 'gift' && properties._gff_set_bundle && !setTokens.has(properties._gff_set_bundle)) {
        updates[item.key] = 0;
      }
    }
    if (Object.keys(updates).length) {
      await request('cart/update.js', { updates });
      await refresh();
    }
  }

  function scheduleCleanup() {
    if (cleanupPending) return;
    cleanupPending = true;
    serialize(removeOrphanGifts).catch(error => {
      document.dispatchEvent(new CustomEvent('gff:cart-error', { detail: { message: error.message } }));
    }).finally(() => { cleanupPending = false; });
  }

  window.GFFCart = Object.freeze({
    add(items) {
      return serialize(async () => {
        if (!Array.isArray(items) || !items.length) throw new Error('Select a product before adding it to your cart.');
        const result = await request('cart/add.js', { items });
        await open();
        return result;
      });
    },
    open,
    reconcile: () => serialize(removeOrphanGifts)
  });

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-gff-open-cart]');
    if (!link) return;
    event.preventDefault();
    open().catch(() => window.location.assign(`${root}cart`));
  });
  for (const eventName of ['cart-loaded', 'cart-updated', 'item-removed']) {
    window.addEventListener(`aftersell-upcart:public-events:${eventName}`, scheduleCleanup);
  }
})();
